import {AggregationType} from '@hconnect/common/types'
import {capitalize} from 'lodash'

import {KpiAggregationTypeOption} from '../types'

export const mapAggregationTypesToOptions = (
  types: AggregationType[],
  t: (key: string) => string,
  isAggregationTypeOption: boolean
): KpiAggregationTypeOption[] =>
  types
    .filter(
      (type) => !(!isAggregationTypeOption && type === AggregationType.AlternativeFuelRateLogic)
    )
    .map((type) => ({
      id: type,
      label:
        type === AggregationType.WeightAverage
          ? t('kpiCalculationSettings.label.weightAverage')
          : type === AggregationType.AlternativeFuelRateLogic
            ? t('kpiCalculationSettings.label.alternativeFuelRateLogic')
            : capitalize(type),
      disabled: isAggregationTypeOption && type === AggregationType.AlternativeFuelRateLogic
    }))
